import { LOCALE_ES } from '@growtherapy/i18n';

export interface LocaleDetectionPromptConfig {
  headerText: string;
  bodyText: string;
  actionCta: string;
}

// Hard-coded to avoid loading alternative language files before the user has chosen a language
export const LOCALE_DETECTION_PROMPT_CONFIG: Partial<Record<string, LocaleDetectionPromptConfig>> = {
  [LOCALE_ES]: {
    headerText: 'Cambie su idioma a español',
    bodyText:
      'Su navegador está en español. Puede elegir utilizar Grow en inglés o en español. Puede cambiar el idioma en cualquier momento utilizando el selector de idioma en el menú o en el pie de página.',
    actionCta: 'Cambiar a español',
  },
};
